import {
  AnimationTriggerMetadata,
  animate,
  keyframes,
  style,
  transition,
  trigger,
} from '@angular/animations';

export function translateAnimation(
  timingIn: number = 100,
  timingOut: number = 100
): AnimationTriggerMetadata {
  return trigger('translateToLeft', [
    transition(':increment', [
      animate(
        timingIn,
        keyframes([
          style({ transform: 'translate(0)', opacity: 1 }),
          style({ transform: 'translate(100%)', opacity: 0 }),
        ])
      ),
      animate(
        timingOut,
        keyframes([
          style({ transform: 'translate(-50%)' }),
          style({ transform: 'translate(0)', opacity: 1 }),
        ])
      ),
    ]),
    transition(':decrement', [
      animate(
        timingOut,
        keyframes([
          style({ transform: 'translate(0)', opacity: 1 }),
          style({ transform: 'translate(-50%)', opacity: 0 }),
        ])
      ),
      animate(
        timingIn,
        keyframes([
          style({ transform: 'translate(100%)'}),
          style({ transform: 'translate(0)', opacity: 1 }),
        ])
      ),
    ]),
  ]);
}
